import React, { Component } from 'react';
import {randomRangeFloat, getRandomInt} from '../../utils/shared.js';
import BRSpan from '../General/BRSpan';
class DonorName extends Component {

    constructor(props) {
        super(props);
        this.state = {
            offScreen: true,
            top: 0,
            right: 0,
            fadeState: 0,
            contentStage: 0 //0 ready to fade out, 1 fade out and go to 2, 2 ready to fade in
        };
        this._nameRef = [];
        this._checkGridTimeout = null;
        this._removeCurrentNameTimeout = null;
        this._startFadeIn = null;
        this._checkCount=0;
        this._rectInfo = null;
        this._gridIndex = null; //for proper removal from grid
        this._id = Math.floor(Math.random() * 10000);
        this._inRemoveQueue = false;
    }

    componentDidMount() {
        this.handleGridCheck();
        this.handleRemove(this.props.fadeOutTime)
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.forceFadeOut!==this.props.forceFadeOut && this.props.forceFadeOut===true){

            clearTimeout(this._checkGridTimeout);
            clearTimeout(this._fadeOut);
            clearTimeout(this._startFadeIn);
            clearTimeout(this._cycleTimeout);
            clearTimeout(this._removeCurrentNameTimeout);
            this._checkGridTimeout = null;
            this._fadeOut = null;
            this._startFadeIn = null;
            this._cycleTimeout = null;
            this._removeCurrentNameTimeout=null;
            this.removeName();

        }
    }

    componentWillUnmount() {
        this.setState({
            offScreen: true //necessary?
        })
        clearTimeout(this._checkGridTimeout);
        clearTimeout(this._fadeOut);
        clearTimeout(this._startFadeIn);
        clearTimeout(this._cycleTimeout);
        clearTimeout(this._removeCurrentNameTimeout);
        this._checkGridTimeout = null;
        this._fadeOut = null;
        this._startFadeIn = null;
        this._cycleTimeout = null;
        this._removeCurrentNameTimeout=null;
    }

    handleRemove = (timeout) => {
        clearTimeout(this._fadeOut);
        this._fadeOut = setTimeout(() => {
            if (!this._inRemoveQueue){
                this._inRemoveQueue=true;
                this.props.removeQueueAdd(this._id);
            }
            if (this.props.allowRemoveRequest(this._id) === true){
                // this.props.releaseGridPoint(this.props.id); //send index!!!
                // this.setState({
                //     fadeState: 3
                // })
                // this._removeCurrentNameTimeout = setTimeout(() => {
                //     this.props.removeCurrentName(this.props.id)
                // }, 3000) //allow time for fadeout
                this.removeName();
            }
            else{
                this.handleRemove(1000);
            }
        }, timeout);
    }

    removeName = () => {
        this.props.releaseGridPoint(this.props.id); //send index!!!
        this.setState({
            fadeState: 3
        })
        this._removeCurrentNameTimeout = setTimeout(() => {
            this.props.removeCurrentName(this.props.id)
        }, 3000) //allow time for fadeout
    }

    handleGridCheck = () => {
        clearTimeout(this._checkGridTimeout);
        this._checkGridTimeout = setTimeout(() => {

            let width = this._nameRef[0].getBoundingClientRect().width
            let height = this._nameRef[0].getBoundingClientRect().height

            let rX,rY;

            if (this.props.avoidBezel === true){
                let hQ, vQ;
                if (this.props.allowedScreens.enabled===true){
                    // console.log('allowedScreens', this.props.allowedScreens);
                    hQ = this.props.allowedScreens.allowedH[Math.floor(Math.random()*this.props.allowedScreens.allowedH.length)];
                    vQ = this.props.allowedScreens.allowedV[Math.floor(Math.random()*this.props.allowedScreens.allowedV.length)];
                    // console.log('hQ', hQ);
                    // console.log('vQ', vQ);
                }
                else{
                    hQ = getRandomInt(0, this.props.hScreens-1)
                    vQ = getRandomInt(0, this.props.vScreens-1)
                }
                let minX = (hQ/this.props.hScreens)*this.props.width;
                let minY = (vQ/this.props.vScreens)*this.props.height;

                rX = randomRangeFloat(minX+ this.props.edgeMargin, minX+(this.props.width/this.props.hScreens)-this.props.edgeMargin-(width)) 
                rY = randomRangeFloat(minY+ this.props.edgeMargin, minY+(this.props.height/this.props.vScreens)-this.props.edgeMargin-(height))
            }
            else{
                rX = randomRangeFloat(this.props.edgeMargin, this.props.width-this.props.edgeMargin-(width)) 
                rY = randomRangeFloat(this.props.edgeMargin, this.props.height-this.props.edgeMargin-(height))
            }


            this._rectInfo = {
                top: rY,
                left: rX,
                right: rX + width,
                bottom: rY + height
            }
            
            let trySetGrid = this.props.trySetGrid(this.props.id, this._rectInfo);
            if (trySetGrid.success === true) {
                this._gridIndex = trySetGrid.gridIndex
                this.setState({
                    offScreen: false,
                    top: this._rectInfo.top,
                    right: this._rectInfo.left,
                    fadeState: 1
                })            
                this._cycleTimeout = setTimeout(() => {
                    this.props.createDonorName(); //creates next donor name
                }, this.props.cycleTime);
                this._startFadeIn = setTimeout(() => { //timeout used so fade class is not added on first frame
                    this.setState({
                        fadeState: 2
                    })       
                }, 10)
            }
            else {
                this._checkCount++;
                this.handleGridCheck();
            }
    }, 20);
    }

    render() {

        let style = { 
            position: 'absolute', 
            whiteSpace: 'nowrap', 
            top: this.state.top, 
            left: this.state.right, 
            fontSize: this.props.fontSize, 
            fontFamily: 'Roboto'
        };
        let className="";
        switch(this.state.fadeState){
            case 0:
            className="opacity0";
            break;
            case 1:
            className="opacity0small";
            break;
            case 2:
            className="fadeablein"
            break;
            case 3:
            className="fadeableout"
            break;
            default:
            break;
        }   

        return (
            <div className={className} ref={(el) => this._nameRef[0] = el} style={style}>
                <span style={{margin: this.props.margin}}><BRSpan str={this.props.name} /></span>
            </div>
        )
    }
}

export default DonorName


// WEBPACK FOOTER //
// ./src/Components/Donor/DonorName.js